import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navigation, subNavigation } from "./navigationMenuData";
import { HomeIcon } from "@heroicons/react/24/outline";

const ContainerShell: React.FC<any> = ({
  children,
  showBreadcrumb,
}) => {
  const [navigationItem, setNavigationItem] = useState<any>();
  const [subNavigationItem, setSubNavigationItem] = useState<any>();

  const location = useLocation();

  useEffect(() => {
    const ni = navigation.find((item) =>
      item.href.startsWith(location.pathname)
    );
    if (!ni) {
      const sni = subNavigation.find((item) =>
        item.href.startsWith(location.pathname)
      );
      if (sni) {
        setSubNavigationItem(sni);
        setNavigationItem(null);
      }
    } else {
      setNavigationItem(ni);
      setSubNavigationItem(null);
    }
  }, [location]);

  return (
    <>
      {showBreadcrumb && (
        <div className="container-shell-header dark:bg-gray-800">
          <nav className="text-sm text-gray-500 dark:text-gray-300">
            <ol className="list-reset flex">
              <li>
                <Link
                  to="/"
                  className="text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-blue-300"
                >
                  <div className="flex flex-row items-center">
                    <HomeIcon className="h-5 w-5 mx-2" />
                    Home
                  </div>
                </Link>
              </li>
              {navigationItem && navigationItem.href !== "/" && (
                <li className="flex items-center">
                  <span className="mx-2">/</span>
                  <Link
                    to={navigationItem.href}
                    className="text-blue-600 hover:text-blue-800"
                  >
                    {navigationItem.name}
                  </Link>
                </li>
              )}
              {subNavigationItem && (
                <li className="flex items-center">
                  <span className="mx-2">/</span>
                  <Link
                    to={subNavigationItem.href}
                    className="text-blue-600 hover:text-blue-800"
                  >
                    {subNavigationItem.name}
                  </Link>
                </li>
              )}
            </ol>
          </nav>
        </div>
      )}
      <div className="container-shell mx-auto">
        <div className="bg-white dark:bg-gray-800 dark:bg-opacity-30 bg-opacity-40 shadow-md rounded p-1">
          {children}
        </div>
      </div>

      <div className="container-shell-footer dark:bg-gray-800 p-1">
        <div className="w-full flex justify-center">
        <span className="m-0 text-xs text-gray-200 ">
          v{__APP_VERSION__}
        </span>
        </div>
      </div>
    </>
  );
};

export default ContainerShell;
